module.exports = __webpack_public_path__ + "82661a3ad8785aa170d94ba8c03c565d.svg";